export default __webpack_public_path__ + "static/media/elect.f860f92b.jpg";